import { jsx } from "react/jsx-runtime";
const Option = ({ value, name, ...other }) => {
  return /* @__PURE__ */ jsx("option", { value, ...other, children: name });
};
var Option_default = Option;
export {
  Option_default as default
};
